import { roundToEndOfDay } from "b2b/utils/date";

export default function getInitialValues() {
  const datumDo = roundToEndOfDay(new Date());

  const datumOd = new Date(datumDo);
  datumOd.setDate(datumOd.getDate() - 30);
  datumOd.setHours(0, 0, 0, 0);

  return { datumOd: datumOd.getTime(), datumDo: datumDo.getTime() };
}
